import {AlertFillIcon} from '@primer/octicons-react'
import styles from './ComposerFallback.module.css'

/** Fallback to use in place of commment editing surfaces. */
export function ComposerFallback() {
  return (
    <div className={styles.errorFallback}>
      <AlertFillIcon className="mr-2" /> The comment editing form cannot be displayed. Please reload the page to try
      again.
    </div>
  )
}
